import { render, staticRenderFns } from "./ProductInShowroom.vue?vue&type=template&id=5c075e8a&functional=true"
import script from "./ProductInShowroom.vue?vue&type=script&lang=js"
export * from "./ProductInShowroom.vue?vue&type=script&lang=js"
import style0 from "./ProductInShowroom.vue?vue&type=style&index=0&id=5c075e8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports